import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useOnNavigateIn } from '@provider-portal/common/hooks/useOnNavigateIn';

import { logoutAsync, NetworkRequestState, selectIsUserLoggedIn } from '@bolteu/redux-session';

import { selectLogoutRequestState } from 'rdx/session/selectors';

export function Logout() {
  const history = useHistory();
  const logoutRequestState = useSelector(selectLogoutRequestState);
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const dispatch = useDispatch();

  const logoutRedirect = () => {
    if (isUserLoggedIn) {
      dispatch(logoutAsync.request({ shouldResetToken: true }));
    } else {
      history.push('/');
    }
  };

  useEffect(() => {
    if (logoutRequestState === NetworkRequestState.success && !isUserLoggedIn) {
      history.push('/');
    }
  });

  useOnNavigateIn(logoutRedirect);
  return null;
}
